<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Dispositivos</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Dispositivo</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
              </el-select>
  
              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="query"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="dispositivos"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
              <div slot="empty" v-if="dispositivos">
                Sin datos disponibles
              </div>
              <el-table-column label="Nombre" prop="nombre" />
              <el-table-column label="Tipo">
                  <div slot-scope="{ row }">
                    {{ findType(row.tipo) ? findType(row.tipo).label : 'N/A' }}
                  </div>
                </el-table-column>
              <el-table-column label="Identificador" prop="identificador" />
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editDispositivo(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button v-if="row.active" class="hover-apolo" type="primary" icon size="sm" @click="deactivateDispositivo(row)">
                    <span class="btn-inner--text">Desactivar</span>
                  </base-button>
                  <base-button  v-else class="hover-apolo" type="primary" icon size="sm" @click="activateDispositivo(row)">
                    <span class="btn-inner--text">Activar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear Dispositivo</h6>
        <form class="new-event--form" @submit.prevent="addDispositivo">
          <base-input label="Nombre"
                      placeholder="Nombre del Dispositivo"
                      v-model="dispositivo.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Seleccione un tipo">
            <multiselect v-model="selectType" :options="tipos" placeholder="Selecccione un tipo" label="label" track-by="id"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.tipo" />
          <base-input label="Identificador"
                      placeholder="Identificador del Dispositivo"
                      v-model="dispositivo.identificador"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.identificador" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addDispositivo">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar Dispositivo</h6>
        <form class="new-event--form" @submit.prevent="editDispositivo">
          <base-input label="Nombre"
                      placeholder="Nombre del Dispositivo"
                      v-model="dispositivo.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Seleccione un tipo">
            <multiselect v-model="selectType" :options="tipos" placeholder="Selecccione un tipo" label="label" track-by="id"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.tipo" />
          <base-input label="Identificador"
                      placeholder="Identificador del Dispositivo"
                      v-model="dispositivo.identificador"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.identificador" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateDispositivo">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import Multiselect from 'vue-multiselect'
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ValidationError from "@/components/ValidationError.vue";
  import formMixin from "@/mixins/form-mixin";
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      ValidationError,
      Multiselect,
      Modal,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        dispositivos: [],
        tipos: [{ id: 1, label: 'MAC Address'}, { id: 2, label: 'Android ID'}],
        selectType: null,
        selectedRows: [],
        query: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 Dispositivos por página'},
          {value:'10', descripcion: '10 Dispositivos por página'},
          {value:'25', descripcion: '25 Dispositivos por página'},
          {value:'50', descripcion: '50 Dispositivos por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        dispositivo: {
            type: "dispositivos",
          tipo: 1,
          nombre: null,
          identificador: null,
        }
      };
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
        selectType: function(newVal) {
            if(newVal) {
                this.dispositivo.tipo = newVal.id;
                return;
            }

            this.dispositivo.tipo = null;
        },
      query: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },

    mounted() {
      //this.getDispositivos();
    },
  
    methods: {
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { nombre: this.query } : {}),
            ...(this.query ? { identificador: this.query } : {}),
            ...(this.query ? { tipo: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
  
        await this.$store.dispatch("dispositivos/list", params).then(() => {
          this.dispositivos = this.$store.getters["dispositivos/list"];
          this.total = this.$store.getters["dispositivos/listTotal"];
        });
        this.loading = false;
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.dispositivo.nombre = null;
        this.dispositivo.tipo = null;
        this.dispositivo.identificador = null;
      },

      async addDispositivo(){
        try {
        await this.$store.dispatch("dispositivos/add", this.dispositivo);

        this.$notify({
          type: "success",
          message: "Dispositivo creado satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editDispositivo(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.dispositivo.nombre = row.nombre;
        this.dispositivo.tipo = row.tipo;
        this.dispositivo.identificador = row.identificador;
        this.dispositivo.id = row.id;
        this.selectType = this.findType(row.tipo);
      },

      async updateDispositivo() {
        try{
          await this.$store.dispatch("dispositivos/update", this.dispositivo);
          this.$notify({
            type: "success",
            message: "Dispositivo actualizada satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      async activateDispositivo(row) {
        const confirmation = await swal.fire({
          title: `¿Desea activar este Dispositivo?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Activar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("dispositivos/activate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Dispositivo activado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      async deactivateDispositivo(row) {
        const confirmation = await swal.fire({
          title: `¿Desea desactivar este Dispositivo?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Desactivar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("dispositivos/deactivate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Dispositivo desactivado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },

      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
      findType(id) {
        let data = this.tipos.filter(item => item.id == id);

        return data.length ? data[0] : null;
      }
    },
  };
  </script>
  <style>
    
  </style>